<section id="benefits" class="relative scroll-mt-28 overflow-hidden border-t border-surface bg-surface-50 dark:bg-white/5">
    <app-landing-glow [variant]="6" />
    <div class="relative z-10 mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
        <div class="max-w-3xl">
            <div class="text-sm font-semibold uppercase tracking-[0.3em] text-primary">{{ text().benefitsTitle }}</div>
            <h2 class="mt-4 text-3xl font-semibold text-surface-900 sm:text-4xl dark:text-white">{{ text().benefitsSubtitle }}</h2>
        </div>

        <div class="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            @for (card of text().benefitsCards; track card.title; let i = $index) {
                <article [appRevealOnScroll]="i * 90" class="rounded-3xl border border-surface bg-surface-0 p-6 shadow-lg shadow-black/10 dark:bg-white/5">
                    <div class="flex h-9 w-9 items-center justify-center rounded-full bg-emerald-500/15 text-emerald-500">
                        <i [class]="'pi ' + benefitsIcons[i]"></i>
                    </div>
                    <h3 class="mt-4 text-lg font-semibold text-surface-900 dark:text-white">{{ card.title }}</h3>
                    <p class="mt-2 leading-7 text-muted-color">{{ card.description }}</p>
                </article>
            }
        </div>

        <div class="mt-10 grid gap-8 rounded-[2rem] border border-primary/15 bg-surface-0 p-8 text-surface-900 shadow-2xl shadow-black/10 dark:bg-surface-950 dark:text-surface-0 sm:p-10 lg:grid-cols-[1fr_1.3fr] lg:items-center">
            <div>
                <h3 class="text-2xl font-semibold text-surface-900 dark:text-surface-0">{{ text().statsHeadline }}</h3>
                <p class="mt-3 leading-7 text-surface-700 dark:text-surface-300">{{ text().statsSubtitle }}</p>
            </div>
            <div class="grid gap-6 sm:grid-cols-3">
                @for (stat of text().stats; track stat.label; let i = $index) {
                    <div [appRevealOnScroll]="i * 90">
                        <div class="text-3xl font-bold text-surface-900 dark:text-surface-0">{{ stat.value }}</div>
                        <div class="mt-1 font-semibold text-surface-900 dark:text-surface-0">{{ stat.label }}</div>
                        <p class="mt-1 text-sm text-surface-700 dark:text-surface-300">{{ stat.description }}</p>
                    </div>
                }
            </div>
        </div>
    </div>
</section>
